/**
 * Base de toda chamada ao middleware.
 *
 * É sempre `/api`: em desenvolvimento o proxy do Vite encaminha para o
 * middleware local, em produção o Traefik roteia para o mesmo host. Não existe
 * URL de ambiente espalhada pelo código.
 */
export const BASE_API = '/api';

/**
 * Toda requisição precisa mandar o cookie de sessão.
 *
 * `wms_sessao` é HttpOnly — o JavaScript não o lê nem o escreve. Sem
 * `credentials: 'include'` o navegador simplesmente não o envia e o painel
 * pareceria deslogado a cada chamada.
 */
export const CREDENCIAIS: RequestCredentials = 'include';
